import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import { get, omit } from 'lodash';

import { AnalyticsContext } from './AnalyticsProvider';

import logger from 'itrvl-logger';
const log = logger(__filename);

export class TrackedDialog extends Component {
  static contextType = AnalyticsContext;

  componentDidMount() {
    // Did we render initially open?
    if (this.props.open) {
      this.trackOpenClose(this.props.open);
    }
  }

  componentDidUpdate(prevProps) {
    // Did we change state?
    if (prevProps.open !== this.props.open) {
      this.trackOpenClose(this.props.open);
    }
  }

  trackOpenClose(open) {
    const props = get(this.props, 'analyticsProperties', {});
    props.location = this.props.location.pathname;

    log.debug('track', open ? 'open dialog' : 'close dialog', props);
    if (open) {
      this.context.analytics().track('open dialog', props);
    } else {
      this.context.analytics().track('close dialog', props);
    }
  }

  render() {
    const ref = this.props.forwardRef;
    const props = omit(this.props, ['analyticsProperties', 'onClick', 'location', 'history', 'match', 'staticContext', 'forwardRef']);
    return (
      <Dialog ref={ref} {...props}>
        {this.props.children}
      </Dialog>
    );
  }
}

export default withRouter(TrackedDialog);
